import { Component, computed } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { injectLeafRouteData } from '../leaf-route-data';

@Component({
  selector: 'mw-app-content-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app-content-layout.component.html',
  styleUrl: './app-content-layout.component.scss'
})
export class AppContentLayoutComponent {
  private readonly leafRouteData = injectLeafRouteData();

  protected readonly fullBleed = computed(
    () => this.leafRouteData()['fullBleed'] === true
  );

  protected readonly fixedHeight = computed(
    () => this.leafRouteData()['fixedHeight'] === true
  );
}
